import { CopyInput } from 'foundations-components/transitional/components/CopyInput';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { jsx as _jsx } from "react/jsx-runtime";
export function EnterpriseManagedAuthAccountId({
  label,
  value,
  helpText,
  hasBottomMargin = false
}) {
  return /*#__PURE__*/_jsx(FormControl, {
    label: label,
    help: helpText,
    marginBlockEnd: hasBottomMargin ? '400' : undefined,
    children: /*#__PURE__*/_jsx(CopyInput, {
      value: value
    })
  });
}